// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-loader {
  margin: 0 auto;
}

.dispatchLiteDetailsWindow {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/window/window.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AACA;EACI,WAAA;AAEJ","sourcesContent":[".center-loader{\n    margin:0 auto;\n}\n.dispatchLiteDetailsWindow{\n    width:100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
